// extracted by mini-css-extract-plugin
export var linkText = "_lx-0";